import { useSelector } from 'react-redux';
import { useRouteLoaderData } from 'react-router';
import { deepEqual } from '../../../../../common/utils/objectUtils.js';
import { pendingSubscriptionActionExistsInState } from '../../../../../common/utils/subscriptionUtils.js';
import { VoiceSubscriptionTimeSettings } from '../../../../../components/SubscriptionDetails/VoiceSubscriptionTimeSettings.js';
import { VoiceSubscriptionLayout } from '../../../../../components/SubscriptionLayout/VoiceSubscriptionLayout.js';
import type { MobileSubscriptionLoaderResponse } from '../../../../../common/loaders.js';
import type { State } from '../../../../../selfservice/common/store.js';

export const VoiceSubTimeSettingsPath = () => {
  const { subscription, hasPendingActions, companyInfo, contacts, addOnRules, addOnRulesMobilePbx } =
    useRouteLoaderData('voiceSub') as MobileSubscriptionLoaderResponse;
  const subscriptionActionsState = useSelector((s: State) => s?.selfservice?.pendingSubscriptionActions, deepEqual);

  return (
    <VoiceSubscriptionLayout
      addOnRules={addOnRules}
      addOnRulesMobilePbx={addOnRulesMobilePbx}
      contacts={contacts}
      companyInfo={companyInfo}
      subscription={subscription}
    >
      <VoiceSubscriptionTimeSettings
        subscription={subscription}
        hasPendingActions={
          hasPendingActions ||
          pendingSubscriptionActionExistsInState(subscription.subscriptionId, subscriptionActionsState)
        }
      />
    </VoiceSubscriptionLayout>
  );
};
